module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  api: {
    //REAPI_URL: "http://localhost:8800/api",
    REAPI_URL: "https://api.til.mn/api",
  },
};
